import { useCallback } from 'react';
import { AnalyticsEvent } from './analytics.types';
import { analyticsClient } from './analyticsClient';

export interface UseAnalyticsReturn {
  track: (event: AnalyticsEvent) => void;
}

export const useAnalytics = (): UseAnalyticsReturn => {
  const track = useCallback((event: AnalyticsEvent) => {
    analyticsClient.track(event);
  }, []);
  return { track };
};
